import {
    LazyImport,
    LazyModule,
    createLazyComponent,
    registerLazyOrchestrator,
} from 'owa-bundling';
import { runAfterBootstrap } from 'owa-delayed-initialization';
import { ComponentClass } from 'react';
export { ComponentClass };
import { getSuggestions, searchSessionStarted } from 'owa-search/lib/actions/publicActions';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "MailSearch", webpackPrefetch: true */ './lazyIndex')
);

// Export components
export let SearchHeaderFirstRowContent = createLazyComponent(
    lazyModule,
    m => m.SearchHeaderFirstRowContent
);

// Export lazy loaded components
export const SearchRefiners = createLazyComponent(lazyModule, m => m.SearchRefiners);

// Export store stuff
export { default as MailSearchStore } from './store/schema/MailSearchStore';
export {
    SupportedFilesHubSuggestionKindType,
    SUPPORTED_FILESHUB_SUGGESTION_KIND_LIST,
} from './store/schema/constants';
export { default as mailSearchStore, defaultMailSearchStore, getStore } from './store/store';
export { FoldersSearchScope } from './utils/getSearchScopeDisplayName';

// Export actions
export {
    clearSearchScope,
    loadMessageSuggestionIntoTable,
    loadTableViewFromSearchTableQuery,
    LoadTableViewFromSearchTableQueryActionMessage,
    removeSearchTableFromStore,
    selectPreviousNode,
    setStaticSearchScope,
} from './actions/publicActions';
export const lazySetStaticSearchScopeData = new LazyImport(
    lazyModule,
    m => m.setStaticSearchScopeData
);

// Export lazy loaded actions
export const lazyRegisterSearchStoreOrchestrators = new LazyImport(
    lazyModule,
    m => m.registerSearchStoreOrchestrators
);
export const lazyStartSearchWithCategory = new LazyImport(
    lazyModule,
    m => m.startSearchWithCategory
);

// Export from owa-persona
export const lazyInitializeLivePersonaCard = new LazyImport(
    lazyModule,
    m => m.initializeLivePersonaCard
);
export const lazyPersonaControlStore = new LazyImport(lazyModule, m => m.personaControlStore);

// Export utils
export { default as getFolderIdFromTableView } from './utils/getFolderIdFromTableView';
export let lazyCreateFallbackPersonaSearchTableQuery = new LazyImport(
    lazyModule,
    m => m.createFallbackPersonaSearchTableQuery
);

export let lazyCreateFallbackPrivateDistributionListSearchTableQuery = new LazyImport(
    lazyModule,
    m => m.createFallbackPrivateDistributionListSearchTableQuery
);

export let lazyCreateFallbackCategorySearchTableQuery = new LazyImport(
    lazyModule,
    m => m.createFallbackCategorySearchTableQuery
);

// Export selectors
export { default as getSearchProvider, SearchProvider } from './selectors/getSearchProvider';

// Register lazy orchestrator
registerLazyOrchestrator(getSuggestions, lazyModule, m => m.getSuggestionsOrchestrator);
registerLazyOrchestrator(searchSessionStarted, lazyModule, m => m.searchSessionStartedOrchestrator);

runAfterBootstrap(() => {
    lazyRegisterSearchStoreOrchestrators.import();
});
